module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('main-header', {
    attrs: {
      "display-name": _vm.displayName,
      "picture-url": _vm.user.profileImageUrl
    }
  }), _vm._v(" "), _c('sidebar', {
    attrs: {
      "display-name": _vm.displayName,
      "picture-url": _vm.user.profileImageUrl
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('content-header'), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('footer', {
    staticClass: "main-footer"
  }, [_c('strong', [_vm._v("\n      Copyright © " + _vm._s(_vm.year) + " "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("HashStudioz")]), _vm._v(".\n    ")]), _vm._v("\n    All rights reserved.\n  ")])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9fac8cc0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9fac8cc0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/main/Main.vue
// module id = 2369
// module chunks = 0